import { useState } from "react";
import { Input, Button, Table, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import request from "../../util/request";
import PointsModal from "../../components/points/pointsModal";
import "./PointsPage.css";

const PointsExpandPage = () => {
  const [id, setId] = useState("");
  const [points, setPoints] = useState("");
  const [data, setData] = useState([]);
  // const [pageSize, setPageSize] = useState(10);
  // const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [detailData, setDetailData] = useState(null);

  const onIdInput = (e) => {
    setId(e.target.value);
  };
  const onPointsInput = (e) => {
    setPoints(e.target.value);
  };
  const goDispatch = () => {
    setTitle("发放确认");
    setIsModalOpen(true);
    setDetailData({ total: data.length, points, type: "user", userId: id });
  };
  const goDetail = () => {
    setTitle("查看个人明细");
    setIsModalOpen(true);
    setDetailData({ userId: id });
  };

  // 根据id最多仅能查询到1条数据
  const getSearchData = async () => {
    setLoading(true);
    try {
      const res = await request.get(
        `/api/xcx-user/parent/totalIntegral?number=${id}`
      );
      setData(Object.keys(res).length ? [res] : []);
    } catch (error) {
      message.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (!data.length) return;
  //   getSearchData();
  // }, [pageSize, pageNum]);

  const columns = [
    {
      title: "序号",
      dataIndex: "no",
      render: (text, record, index) => index + 1,
    },
    { title: "昵称", dataIndex: "nickName" },
    { title: "ID号", dataIndex: "number" },
    { title: "积分余额", dataIndex: "totalIntegral" },
    {
      title: "操作",
      dataIndex: "resultType",
      render: (_, { resultType, taskId }) => {
        return (
          <a type="primary" onClick={goDetail}>
            查看个人明细
          </a>
        );
      },
    },
  ];

  const handleClose = (status) => {
    setIsModalOpen(false);
    if (status === "success" && id) {
      getSearchData();
    }
  };

  return (
    <div className="points-container">
      <div className="middlePart search-mod">
        <div className="points-left">
          <Input
            value={id}
            onInput={onIdInput}
            className="input"
            placeholder="输入用户ID"
          />
          <Button
            loading={loading}
            onClick={getSearchData}
            type="primary"
            icon={<SearchOutlined />}
            iconPosition="start"
            disabled={!id}
          >
            Search
          </Button>
        </div>
        <div className="points-right">
          <span style={{ marginRight: "8px" }}>输入补偿积分数量</span>
          <Input
            value={points}
            onInput={onPointsInput}
            className="input"
            placeholder="+/-30"
            style={{ width: "150px" }}
          />
          <Button
            disabled={!points || !data.length}
            onClick={goDispatch}
            type="primary"
          >
            发放
          </Button>
        </div>
      </div>
      <div className="table">
        <Table
          columns={columns}
          dataSource={data}
          // pagination={{
          //   current: pageNum,
          //   pageSize: pageSize,
          //   onChange: (pageNum, pageSize) => {
          //     setPageNum(pageNum);
          //     setPageSize(pageSize);
          //   },
          //   showSizeChanger: true,
          //   pageSizeOptions: ["10", "20", "50", "100"],
          // }}
          loading={loading}
          rowKey="number"
        />
      </div>
      <PointsModal
        title={title}
        visible={isModalOpen}
        footer={[]}
        closeDialog={handleClose}
        data={detailData}
      />
    </div>
  );
};

export default PointsExpandPage;
